// Component vars
export const TOPBAR_TITLE = "Ateliers Jeunes"
export const TOPBAR_SUBTITLE = "Interface de gestion"
